import isArray from 'lodash/isArray';
import reduce from 'lodash/reduce';

/**
 * returns flat list of errors codes regardless of which field / pointer they originated from
 * @param  {Error}  clientError axios client error
 * @return {Object}
 */
export function extractErrorCodes(clientError) {
  const extracted = clientError?.response?.data?.errors;
  if (isArray(extracted)) {
    return reduce(
      extracted,
      (acc, err) => {
        const { code } = err;
        acc[code] = code;
        return acc;
      },
      {}
    );
  } else {
    return {};
  }
}
